import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [forgot, setForgot] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");
  const [forgotMsg, setForgotMsg] = useState("");
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("ih_token", data.token);
      navigate("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Autentificare eșuată");
    } finally {
      setLoading(false);
    }
  };

  const submitForgot = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email: forgotEmail });
      setForgotMsg(data.message);
    } catch {
      setForgotMsg("Dacă adresa există, am trimis un link de resetare.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-sm bg-cream-light border border-warm-grey/50 rounded-3xl p-8 shadow-xl shadow-main/5">
        <img src="/assets/logo-line.webp" alt="Imperfect House" className="h-10 w-auto mix-blend-multiply" />
        <h1 className="mt-6 font-serif text-3xl text-main">Panou administrare</h1>
        <p className="mt-1 text-sm text-brown/60">Autentificare pentru Mihai</p>

        {!forgot ? (
          <form onSubmit={submit} className="mt-8 space-y-4">
            <input
              type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="Email" data-testid="admin-email"
              className="w-full bg-cream border border-warm-grey/60 rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-terracotta/50"
            />
            <input
              type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              placeholder="Parolă" data-testid="admin-password"
              className="w-full bg-cream border border-warm-grey/60 rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-terracotta/50"
            />
            {error && <p className="text-sm text-terracotta font-semibold" data-testid="admin-login-error">{error}</p>}
            <button type="submit" disabled={loading} data-testid="admin-login-submit"
              className="w-full rounded-full bg-main text-cream-light font-semibold py-3.5 hover:bg-terracotta disabled:opacity-50 transition-colors">
              {loading ? "Se verifică…" : "Intră în cont"}
            </button>
            <button type="button" onClick={() => setForgot(true)} data-testid="forgot-toggle"
              className="w-full text-center text-xs text-brown/50 hover:text-terracotta transition-colors">
              Ai uitat parola?
            </button>
          </form>
        ) : (
          <form onSubmit={submitForgot} className="mt-8 space-y-4" data-testid="forgot-form">
            <p className="text-sm text-brown/70">Introdu emailul de admin și îți trimitem un link de resetare (valabil 1 oră).</p>
            <input
              type="email" required value={forgotEmail} onChange={(e) => setForgotEmail(e.target.value)}
              placeholder="Email" data-testid="forgot-email"
              className="w-full bg-cream border border-warm-grey/60 rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-terracotta/50"
            />
            {forgotMsg && <p className="text-sm text-green-dark font-semibold" data-testid="forgot-success">{forgotMsg}</p>}
            <button type="submit" disabled={loading} data-testid="forgot-submit"
              className="w-full rounded-full bg-main text-cream-light font-semibold py-3.5 hover:bg-terracotta disabled:opacity-50 transition-colors">
              {loading ? "Se trimite…" : "Trimite linkul de resetare"}
            </button>
            <button type="button" onClick={() => { setForgot(false); setForgotMsg(""); }} data-testid="forgot-back"
              className="w-full text-center text-xs text-brown/50 hover:text-terracotta transition-colors">
              ← Înapoi la autentificare
            </button>
          </form>
        )}
        <a href="/" className="mt-6 block text-center text-xs text-brown/50 hover:text-terracotta">← Înapoi la site</a>
      </div>
    </div>
  );
}
